import { ChecklistComponent } from '@infield/features/checklist';
import { useDisableOverscrollWhenOfflineMobile } from '@infield/hooks/use-disable-scroll-when-offline-mobile';
import type { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const ActivityChecklistMobile: FC = () => {
  const { activityId } = useParams();
  const navigate = useNavigate();
  useDisableOverscrollWhenOfflineMobile();

  const handleOnTitleClick = (activityExternalId: string) => {
    navigate(`/activity/${encodeURIComponent(activityExternalId)}/details`);
  };

  const handleOnAssetClick = (assetExternalId: string) => {
    navigate(`/asset/${encodeURIComponent(assetExternalId)}`);
  };

  if (activityId)
    return (
      <ChecklistComponent
        checklistId={activityId}
        onTitleClick={handleOnTitleClick}
        onAssetClick={handleOnAssetClick}
      />
    );
  return <div>ActivityChecklist: {activityId} is not available</div>;
};
